import React, { Component } from "react";
import clsx from 'clsx';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import { Icon, IconButton, SnackbarContent } from "@material-ui/core";
import { alertActions } from './../_actions/alert.actions';
import { useDispatch, useSelector } from 'react-redux';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
}));

const AlertSnack = ({type,message,autoclose}) =>{
  const classes = useStyles();
  const [open, setOpen] = React.useState(true);
  const dispatch = useDispatch();

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
    dispatch(alertActions.clear());
  };
  console.log(type);
  return ( 
    <div className={classes.root}>      
      <Snackbar anchorOrigin={{ vertical:'bottom', horizontal:'center'}} open={open}  onClose={handleClose}>   
      <Alert onClose={handleClose} severity={type} autoHideDuration={autoclose}>
         {message}
        </Alert> 
     
      </Snackbar>
        
    </div>
  );

}
export default AlertSnack;